import React from "react";
import PropTypes from "prop-types";
import useDrawer from "./UseDrawer";
import EMPDrawer from "./EMPDrawer";

const DrawerContext = React.createContext();
const { Provider } = DrawerContext;

const DrawerProvider = ({ children }) => {
  const {
    openDrawer,
    handleDrawer,
    drawerContent,
    drawerHeading,
    drawerAnchor,
  } = useDrawer();

  return (
    <Provider
      value={{
        openDrawer,
        handleDrawer,
        drawerContent,
        drawerHeading,
        drawerAnchor,
      }}
    >
      <EMPDrawer drawerAnchor={drawerAnchor} />
      {children}
    </Provider>
  );
};

DrawerProvider.propTypes = {
  children: PropTypes.node,
};

export { DrawerContext, DrawerProvider };
